<template>
  <main class="main csgo-products-page page-inside">
    <div class="main-wrapper">
      <section class="section hero-section product-list-section">
        <div class="wrapper">
          <router-link to="/" class="back">
            <img src="./../assets/back.svg" class="img" />
            <span class="desc">{{ $t("Back") }}</span>
          </router-link>
          <div class="title big">{{ $t("CS:GO Products") }}</div>
          <div class="top">
            <div class="wrapper">
              <div class="left">
                <div
                  :class="['filter-btn', { active: filtersIsVisible }]"
                  @click="openFilter"
                >
                  <div class="filter-btn-wrapper">
                    <img src="./../assets/fillter.svg" class="img" />
                    <span class="desc">{{ $t("Filter") }}</span>
                    <img src="./../assets/arrow-down.svg" class="img" />
                  </div>
                </div>
              </div>
              <div class="right">
                <div class="search">
                  <input v-model="search" />
                </div>
                <div class="select-container" v-if="sortOptions.length">
                  <div class="desc">{{ $t("Sort:") }}</div>
                  <Select2
                    class="select2 single"
                    v-model="sort"
                    :options="sortOptions"
                    placeholder="Highest price first"
                    @select="selectSort($event)"
                  />
                </div>
              </div>
            </div>
            <transition name="slide">
              <div class="filters" v-if="filtersIsVisible">
                <div class="filters-wrapper">
                  <div class="select-container" v-if="categoryOptions.length">
                    <div class="desc">{{ $t("Category:") }}</div>
                    <Select2
                      class="select2 single"
                      v-model="category"
                      :options="categoryOptions"
                      placeholder="All categories"
                      @select="selectCategory($event)"
                    />
                  </div>
                  <div class="select-container" v-if="qualityOptions.length">
                    <div class="desc">{{ $t("Quality:") }}</div>
                    <Select2
                      class="select2 single"
                      v-model="quality"
                      :options="qualityOptions"
                      placeholder="All quality"
                      @select="selectQuality($event)"
                    />
                  </div>
                  <div class="select-container select-container-range">
                    <div class="desc">{{ $t("Price:") }}</div>
                    <div class="val min desc">
                      {{ barMinValue }} {{ $parent.currency }}
                    </div>
                    <MultiRangeSlider
                      :min="0"
                      :max="1200"
                      :step="10"
                      :ruler="false"
                      :label="false"
                      :rangeMargin="0"
                      :minValue="barMinValue"
                      :maxValue="barMaxValue"
                      @input="updateRangeValues"
                    />
                    <div class="val max desc">
                      {{ barMaxValue }} {{ $parent.currency }}
                    </div>
                  </div>
                  <div class="select-container select-container-reset">
                    <div class="reset" @click="resetFilters">
                      <img src="./../assets/refreshing.svg" class="img" />
                      <div class="desc">{{ $t("Reset") }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <transition name="fade">
            <div class="list products" v-if="productList">
              <div class="item" v-for="(item, i) in productList" :key="i">
                <div class="item-wrapper">
                  <div class="desc">{{ item.category }}</div>
                  <a @click="$parent.goToProduct(item)" class="title">{{
                    item.title
                  }}</a>
                  <a @click="$parent.goToProduct(item)" class="preview">
                    <img :src="imgDomain + item.img_url" class="img" />
                    <transition name="fade">
                      <span
                        class="title"
                        v-if="$parent.addToCartChosenItem == item.id"
                        >Added</span
                      >
                    </transition>
                  </a>
                  <div class="price title">
                    <span class="discount" v-if="item.old_price != '0.00'"
                      >{{ item.old_price }} {{ $parent.currency }}</span
                    >
                    <span>{{ item.price }} {{ $parent.currency }}</span>
                  </div>
                  <a class="link" @click="$parent.addToCart(item, item.id)">
                    <span>{{ $t("Add to") }}</span>
                    <svg
                      id="shopping-cart_1_"
                      data-name="shopping-cart (1)"
                      xmlns="http://www.w3.org/2000/svg"
                      width="19.367"
                      height="18.119"
                      viewBox="0 0 19.367 18.119"
                    >
                      <path
                        id="Контур_3"
                        data-name="Контур 3"
                        d="M50.367,94.873H35.607L34.745,91H31v1.291h2.71l2.462,11.125h-.008a3.109,3.109,0,0,0,1.607,2.712,1.942,1.942,0,1,0,3.439.408h4.111a1.919,1.919,0,0,0-.119.646,1.937,1.937,0,1,0,1.937-1.937H39.285a1.829,1.829,0,0,1-1.778-1.417l12.861-2.573Z"
                        transform="translate(-31 -91)"
                        fill="#8d8e92"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </transition>
          <pagination
            v-if="totalProducts"
            v-model="activePage"
            :per-page="20"
            :records="totalProducts"
            @paginate="changePage"
          />
        </div>
      </section>
    </div>
  </main>
</template>
<script>
import Select2 from "vue3-select2-component";
import Pagination from "vue-pagination-2";
import MultiRangeSlider from "multi-range-slider-vue";

export default {
  name: "CsGoProducts",
  props: ["currency", "currencyCode"],
  components: {
    Select2,
    Pagination,
    MultiRangeSlider,
  },
  data: function () {
    return {
      search: "",
      imgDomain: "",
      filtersIsVisible: false,
      sort: "desc",
      category: "",
      quality: "",
      activePage: 1,
      totalProducts: null,
      sortOptions: [
        {
          id: "desc",
          text: "Highest price first",
        },
        {
          id: "asc",
          text: "Lowest price first",
        },
      ],
      categoryOptions: {},
      qualityOptions: {},
      barMinValue: 0,
      barMaxValue: 1200,
      dragged: false,
      productList: {},
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.$http
      .get(process.env.VUE_APP_API + "items/list?page=1&sort=desc")
      .then((res) => {
        this.productList = res.data.payload;
        this.totalProducts = res.data.meta.total;
      })
      .catch((res) => {
        if (res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      });

    this.getCategoryOptions();
    this.getQualityOptions();

    addEventListener("mouseup", () => {
      if (this.dragged) {
        this.filterProducts();
        this.dragged = false;
      }
    });
    addEventListener("touchend", () => {
      if (this.dragged) {
        this.filterProducts();
        this.dragged = false;
      }
    });
  },
  watch: {
    search() {
      this.filterProducts();
    },

    currencyCode: function () {
      this.activePage = 1;
      this.filterProducts();
    },
    currency: function () {
      this.activePage = 1;
      this.filterProducts();
    },
  },
  methods: {
    selectSort(event) {
      this.activePage = 1;
      this.sort = event.id;
      this.filterProducts();
    },
    selectCategory(event) {
      this.activePage = 1;
      this.category = event.text;
      this.filterProducts();
    },
    selectQuality(event) {
      this.activePage = 1;
      this.quality = event.text;
      this.filterProducts();
    },
    resetFilters() {
      this.quality = "All quality";
      this.category = "All categories";
      this.categoryOptions = "";
      this.qualityOptions = "";
      this.getCategoryOptions();
      this.getQualityOptions();
      this.barMinValue = 0;
      this.barMaxValue = 1200;
      this.filterProducts();
    },
    openFilter() {
      this.filtersIsVisible = !this.filtersIsVisible;
    },
    filterProducts() {
      let addCategory = "";
      if (this.category != "All categories") {
        addCategory = "type=" + this.category;
      } else {
        addCategory = "";
      }

      let addQuality = "";
      if (this.quality != "All quality") {
        addQuality = "&quality=" + this.quality;
      } else {
        addQuality = "";
      }
      let addPrice =
        "&price_from=" + this.barMinValue + "&price_till=" + this.barMaxValue;

      let addSort = "&sort=" + this.sort;

      let addPage = "&page=" + this.activePage;

      let addSearch = "&search=" + this.search;

      this.$http
        .get(
          process.env.VUE_APP_API +
            "items/list?" +
            addCategory +
            addQuality +
            addPrice +
            addSort +
            addPage +
            addSearch +
            "&currency=" +
            this.currencyCode,
        )
        .then((res) => {
          console.log(res);
          this.productList = res.data.payload;
          this.totalProducts = res.data.meta.total;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
    changePage(page) {
      this.activePage = page;
      this.filterProducts();
    },
    getCategoryOptions() {
      this.$http
        .get(process.env.VUE_APP_API + "items/filter-data")
        .then((res) => {
          const newCategories = res.data.payload.types.map((item, index) => ({
            id: index + 1, // Смещаем ID, так как 0 зарезервирован для "All categories"
            text: item,
            url: item.toLowerCase().replace(/\s+/g, "-"), // Генерируем url из строки
          }));
          newCategories.unshift({ id: 0, text: "All categories", url: "" });
          this.categoryOptions = newCategories;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
    getQualityOptions() {
      this.$http
        .get(process.env.VUE_APP_API + "items/filter-data")
        .then((res) => {
          let newQuality = res.data.payload.qualities;
          newQuality.unshift("All quality");
          this.qualityOptions = newQuality;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
    updateRangeValues(e) {
      this.activePage = 1;
      this.barMinValue = e.minValue;
      this.barMaxValue = e.maxValue;

      this.dragged = true;
    },
  },
};
</script>
